import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chevron-down-icon',
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" 
         [attr.width]="width" 
         [attr.height]="height" 
         viewBox="0 0 24 24" 
         fill="none">
      <path d="M6 9L12 15L18 9" 
            [attr.stroke]="color" 
            stroke-width="1.5" 
            stroke-linecap="round" 
            stroke-linejoin="round"/>
    </svg>
  `,
  standalone: true
})
export class ChevronDownIconComponent {
  @Input() width: string = '24';
  @Input() height: string = '24';
  @Input() color: string = '#EA5E22';
}
